module.exports = __webpack_public_path__ + "static/media/sara.aa0990b0.png";